import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AttritionData from '../../components/AttritionChartComponent';
import FeedbackData from '../../components/FeedbackChartComponent';
import FreezePane from '../../components/FreezePaneComponent';
import LeaveData from '../../components/LeaveChartComponent';
import MoodData from '../../components/MoodChartComponent';
import MyTeamData from '../../components/MyTeamComponent';
import PerformanceData from '../../components/PerformanceChartComponent';
import RatingData from '../../components/RatingChartComponent';
import SalaryData from '../../components/SalaryChartComponent';
import TabComponent from '../../components/TabComponent';
import TeamCountData from '../../components/TeamCountChartComponent';
import { getDomainData, getEvaluationData, getFormPopUp, previousEvaluationId, setEvaluationPeriodApi } from '../../service/api';
import Activities from '../activities/Activities';
import Loader from '../../StaticComponent/Loader';
import { encryptStorage } from '../../constant';

// import Loader from '../../StaticComponent/Loader';

import moment from 'moment';
import TeamMemberDashboard from '../teammember dashboard/TeamMemberDashboard';
import AttritionDashboard from '../../components/AttritionDashboard';

// import '../../components/css/Dashboard-styles.css'

function OverviewContainer(props) {
    // try{

    const teamCountFilterData = { start_date: '', end_date: '' };
    const ratingFilterData = { domain: '', dates: '' };
    const salaryFilterData = { domain: '', start_date: '', end_date: '' };

    const tempRole = encryptStorage.getItem('role');

    const [isLoading, setIsLoading] = React.useState(true);

    const [popUp, setPopUp] = useState(false);

    const [filterTeamCountData, setFilterTeamCountData] = useState(teamCountFilterData);

    const [filterRatingData, setFilterRatingData] = useState(ratingFilterData);

    const [filterSalaryData, setFilterSalaryData] = useState(salaryFilterData);

    const [passFilterData, setPassFilterData] = useState('');

    const [filterPressed, setFilterPressed] = useState(false);

    const [teamCountSelect, setTeamCountSelect] = useState(true);

    const [ratingSelect, setRatingSelect] = useState(false);

    const [salarySelect, setSalarySelect] = useState(false);

    const [role, setRole] = useState(encryptStorage.getItem('role'));

    const [domains, setDomains] = useState([]);

    const [evaluationPeriod, setEvaluationPeriod] = useState([]);

    const [dateValidationSalary, setDateValidationSalary] = useState('');

    const [flag, setFlag] = useState(false);

    const [filterValue, setFilterValue] = useState('');
    const [filterValueSalary, setFilterValueSalary] = useState('');

    const [Tab, setTab] = useState('');

    // const { state } = useLocation();

    //;

    let search = window.location.search;

    let tab = new URLSearchParams(search).get('tab');

    useEffect(() => {
        setRole(encryptStorage.getItem('role'));

        if (tab) setTab(tab);
        else setTab('');

        fetchApi();
    }, []);

    const fetchApi = async () => {
        await setEvaluationPeriodApi();

        setIsLoading(false);

        const resp = await getFormPopUp();

        if (resp?.data?.ResponseData) setPopUp(resp.data.ResponseData);

        const domainDrop = await getDomainData();

        if (domainDrop?.data?.ResponseData.length) setDomains(domainDrop.data.ResponseData);

        const evalPeriod = await getEvaluationData();

        if (evalPeriod?.data?.ResponseData) setEvaluationPeriod(evalPeriod.data.ResponseData);

        const id = await previousEvaluationId();

        encryptStorage.setItem('PreviousEvaluationId', id?.data?.ResponseData[0]);

        encryptStorage.setItem('CurrentEvaluationId', id?.data?.ResponseData[1]);

        if (tempRole == 'Manager') {
            setSalarySelect(true);

            setTeamCountSelect(false);
        }

        setIsLoading(true);
    };

    const filterTeamOnChange = (e) => {
        setFilterTeamCountData({ ...filterTeamCountData, [e.target.name]: e.target.value });
        setFlag(!flag);
    };

    const filterSalaryOnChange = (e) => {
        setFilterSalaryData({ ...filterSalaryData, [e.target.name]: e.target.value });
        setFlag(!flag);
    };

    const applyFilter = (chart = '', clear = '') => {

        let data;

        if (chart == 'teamCount') {
            data = filterTeamCountData;
        } else if (chart == 'rating') {
            data = filterRatingData;
            setFilterPressed(true);
        } else if (chart == 'salary') {
            data = filterSalaryData;
            setFilterPressed(true);
        }

        if (clear != '') {
            setPassFilterData(clear);

            setFilterPressed(false);
        } else {
            setPassFilterData(data);
        }
    };

    const changeFunction = (tabName) => {
        if (tabName == 'rating') {
            setTeamCountSelect(false);
            setRatingSelect(true);
            setSalarySelect(false);
        } else if (tabName == 'teamcount') {
            setTeamCountSelect(true);
            setRatingSelect(false);
            setSalarySelect(false);
        } else if (tabName == 'salary') {
            setTeamCountSelect(false);
            setRatingSelect(false);
            setSalarySelect(true);
        }
    };

    if (role == 'Manager' || role == 'Hr Manager' || role == 'Hr') {
        return (
            <>
                <Loader isLoading={isLoading} />

                <div className="container-fluid body-bg mt-3">
                    <div className="row">
                        {/*Tab*/}
                        <TabComponent tab={Tab} />
                        <div className="tab-content" id="pills-tabContent">
                            {/* Overview Tab */}
                            <div
                                className={`tab-pane fade ${Tab == '' ? 'show active' : null} `}
                                id="pills-home"
                                role="tabpanel"
                                aria-labelledby="overview-dashboard-tab"
                            >
                                <div className=" d-flex justify-content-between mt-3">
                                    <div className="dashboard-custom-col-38 rounded-5 dashboard-container-background">
                                        <PerformanceData role={encryptStorage.getItem('role')} />
                                    </div>
                                    <div className="dashboard-custom-col-38 rounded-5 dashboard-container-background">
                                        <LeaveData role={encryptStorage.getItem('role')} />
                                    </div>
                                    <div className="dashboard-custom-col-22 rounded-5 dashboard-container-background">
                                        <FeedbackData role={encryptStorage.getItem('role')} />
                                    </div>
                                </div>

                                <div className=" d-flex justify-content-between mt-3">
                                    <div className="dashboard-custom-col-44 rounded-5 dashboard-container-background">
                                        <div className="d-flex justify-content-between">
                                            <ul className="nav nav-pills ps-4" style={{ 'z-index': '1' }} id="pills-tab" role="tablist">
                                                {role == 'Hr Manager' || role == 'Hr' ? (
                                                    <li className="nav-item">
                                                        <button
                                                            onClick={() => {
                                                                changeFunction('teamcount');
                                                            }}
                                                            className="nav-link px-0 me-5 rounded-0 bold-text active db-tab-style font-13"
                                                            id="team-count-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#team-count"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="team-count"
                                                            aria-selected="true"
                                                        >
                                                            Team Count
                                                        </button>
                                                    </li>
                                                ) : null}
                                                {/* <li className="nav-item">
                                                    <button
                                                        onClick={() => {
                                                            changeFunction('rating');
                                                        }}
                                                        className={`nav-link  px-0 me-5 rounded-0 bold-text db-tab-style font-13 ${
                                                            role == 'Manager' ? 'active' : null
                                                        } `}
                                                        id="ratings-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#rating"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="rating"
                                                        aria-selected="false"
                                                    >
                                                        Ratings
                                                    </button>
                                                </li> */}
                                                {role == 'Manager' || role == 'Hr Manager' ? (
                                                    <li className="nav-item">
                                                        <button
                                                            onClick={() => {
                                                                changeFunction('salary');
                                                            }}
                                                            className={`nav-link px-0 me-5 rounded-0 bold-text ${role == 'Manager' ? 'active' : null} db-tab-style font-13`}
                                                            id="salary-range-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#salary-range"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="salary-range"
                                                            aria-selected="false"
                                                        >
                                                            Salary Range
                                                        </button>
                                                    </li>
                                                ) : null}
                                            </ul>
                                            {teamCountSelect ? (
                                                <>
                                                    <div className="dropdown m-2 ">
                                                        <button
                                                            className={`btn ${role == 'Hr Manager' || role == 'Hr' ? 'dashboard-filter-btn' : null
                                                                }  font-12 medium-text`}
                                                            type="button"
                                                            id="dropdownMenuButton127"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            {role == 'Hr Manager' || role == 'Hr' ? 'ALL' : null}
                                                            <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                                                        </button>
                                                        <div className="dropdown-menu dashboard-dashboard-filter-dropdown3 px-3 py-3">
                                                            <div className="row">
                                                                <div className="d-flex justify-content-between">
                                                                    <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                                                    <button className="btn p-0">
                                                                        <img src="/Images/Path 38820.svg" />
                                                                    </button>
                                                                </div>

                                                                <div className="row">
                                                                    <h5 className="font-12 bold-text mt-3">Date Range</h5>
                                                                    <div className="col-md-6">
                                                                        <label className="medium-text font-12 d-flex mb-1">From</label>
                                                                        <input
                                                                            onChange={(e) => {
                                                                                filterTeamOnChange(e);
                                                                            }}
                                                                            type="date"
                                                                            value={filterTeamCountData.start_date}
                                                                            max={filterTeamCountData.end_date}
                                                                            name="start_date"
                                                                            className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                                                            placeholder="Select Domain"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label className="medium-text font-12 d-flex mb-1">To</label>
                                                                        <input
                                                                            onChange={(e) => {
                                                                                filterTeamOnChange(e);
                                                                            }}
                                                                            type="date"
                                                                            value={filterTeamCountData.end_date}
                                                                            min={filterTeamCountData.start_date}
                                                                            name="end_date"
                                                                            className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                                                            placeholder="Select Domain"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex justify-content-end mt-3">
                                                                    <a
                                                                        onClick={() => {
                                                                            setFilterTeamCountData(teamCountFilterData);
                                                                            applyFilter('', teamCountFilterData);
                                                                        }}
                                                                        className="btn hive-btn-secondary me-3"
                                                                    >
                                                                        Clear
                                                                    </a>
                                                                    <button
                                                                        autoFocus
                                                                        onClick={() => {
                                                                            applyFilter('teamCount');
                                                                        }}
                                                                        type="button"
                                                                        className="btn hive-btn-primary dashboard-btn-filter"
                                                                    >
                                                                        Apply
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : ratingSelect ? (
                                                <div className="dropdown m-2 ">
                                                    <button
                                                        className={`btn ${role == 'Hr Manager' || role == 'Hr' ? 'dashboard-filter-btn' : null
                                                            }  font-12 medium-text`}
                                                        type="button"
                                                        id="dropdownMenuButton127"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        {(role == 'Hr Manager' || role == 'Hr') &&
                                                            filterRatingData.domain &&
                                                            filterPressed &&
                                                            filterRatingData.domain != filterValue
                                                            ? `${filterValue}`
                                                            : (role == 'Hr Manager' || role == 'Hr') &&
                                                                filterRatingData.domain &&
                                                                filterPressed
                                                                ? `${filterRatingData.domain}`
                                                                : role == 'Hr Manager' || role == 'Hr'
                                                                    ? `ALL`
                                                                    : null}
                                                        <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                                                    </button>
                                                    <div className="dropdown-menu dashboard-filter-dropdown px-3 py-3">
                                                        <div className="row">
                                                            <div className="d-flex justify-content-between">
                                                                <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                                                <button className="btn p-0">
                                                                    <img src="/Images/Path 38820.svg" />
                                                                </button>
                                                            </div>

                                                            <div className="col-md-12">
                                                                {role == 'Hr Manager' || role == 'Hr' ? (
                                                                    <>
                                                                        <label className="medium-text font-12 d-flex mb-1">Domain</label>
                                                                        <select
                                                                            value={filterRatingData.domain}
                                                                            onChange={(e) => {
                                                                                setFilterRatingData((filterRatingData) => ({
                                                                                    ...filterRatingData,
                                                                                    [e.target.name]: e.target.value,
                                                                                }));
                                                                            }}
                                                                            className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                                                            name="domain"
                                                                        >
                                                                            <option selected value="">
                                                                                Select
                                                                            </option>
                                                                            {domains.map((domain) => {
                                                                                return <option value={domain}>{domain}</option>;
                                                                            })}
                                                                        </select>
                                                                    </>
                                                                ) : null}
                                                            </div>

                                                            <div className="col-md-12">
                                                                <h5 className="font-12 bold-text mt-3">Evaluation Period</h5>
                                                                <select
                                                                    value={filterRatingData.dates}
                                                                    onChange={(e) => {
                                                                        setFilterRatingData((filterRatingData) => ({
                                                                            ...filterRatingData,
                                                                            [e.target.name]: e.target.value,
                                                                        }));
                                                                    }}
                                                                    className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                                                    name="dates"
                                                                >
                                                                    <option selected disabled value="">
                                                                        Evaluation Periods
                                                                    </option>
                                                                    {evaluationPeriod.map((evaluation) => {
                                                                        const valStart = moment(evaluation.start_date).format('YYYY-MM-DD');
                                                                        const valEnd = moment(evaluation.end_date).format('YYYY-MM-DD');

                                                                        return (
                                                                            <option value={valStart + '||' + valEnd}>
                                                                                {moment(evaluation.start_date).format('DD MMM') +
                                                                                    '-' +
                                                                                    moment(evaluation.end_date).format('DD MMM,YYYY')}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                            </div>

                                                            <div className="d-flex justify-content-end mt-3">
                                                                <a
                                                                    onClick={() => {
                                                                        setFilterRatingData(ratingFilterData);
                                                                        applyFilter('', ratingFilterData);
                                                                    }}
                                                                    className="btn hive-btn-secondary me-3"
                                                                >
                                                                    Clear
                                                                </a>
                                                                <button
                                                                    autoFocus
                                                                    onClick={() => {
                                                                        applyFilter('rating');
                                                                        setFilterValue(filterRatingData.domain);
                                                                    }}
                                                                    type="button"
                                                                    className="btn hive-btn-primary dashboard-btn-filter"
                                                                >
                                                                    Apply
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : salarySelect ? (
                                                <>
                                                    <div className="dropdown m-2 ">
                                                        <button
                                                            className={`btn ${role == 'Hr Manager' || role == 'Hr' ? 'dashboard-filter-btn' : null
                                                                }  font-12 medium-text`}
                                                            type="button"
                                                            id="dropdownMenuButton127"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            {(role == 'Hr Manager' || role == 'Hr') &&
                                                                filterSalaryData.domain &&
                                                                filterPressed &&
                                                                filterSalaryData.domain != filterValueSalary
                                                                ? `${filterValueSalary}`
                                                                : (role == 'Hr Manager' || role == 'Hr') &&
                                                                    filterSalaryData.domain &&
                                                                    filterPressed
                                                                    ? `${filterSalaryData.domain}`
                                                                    : role == 'Hr Manager' || role == 'Hr'
                                                                        ? `ALL`
                                                                        : null}
                                                            <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                                                        </button>
                                                        <div className="dropdown-menu dashboard-dashboard-filter-dropdown3 px-3 py-3">
                                                            <div className="row">
                                                                <div className="d-flex justify-content-between">
                                                                    <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                                                    <button className="btn p-0">
                                                                        <img src="/Images/Path 38820.svg" />
                                                                    </button>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    {role == 'Hr Manager' || role == 'Hr' ? (
                                                                        <>
                                                                            <label className="medium-text font-12 d-flex mb-1">
                                                                                Domain
                                                                            </label>
                                                                            <select
                                                                                value={filterSalaryData.domain}
                                                                                onChange={(e) => {
                                                                                    setFilterSalaryData((filterSalaryData) => ({
                                                                                        ...filterSalaryData,
                                                                                        [e.target.name]: e.target.value,
                                                                                    }));
                                                                                }}
                                                                                className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                                                                name="domain"
                                                                            >
                                                                                <option selected value="">
                                                                                    Select
                                                                                </option>
                                                                                {domains.map((domain) => {
                                                                                    return <option value={domain}>{domain}</option>;
                                                                                })}
                                                                            </select>
                                                                        </>
                                                                    ) : null}
                                                                </div>

                                                                <div className="row">
                                                                    <h5 className="font-12 bold-text mt-3">Date Range</h5>
                                                                    <div className="col-md-6">
                                                                        <label className="medium-text font-12 d-flex mb-1">From</label>
                                                                        <input
                                                                            onChange={(e) => {
                                                                                filterSalaryOnChange(e);
                                                                            }}
                                                                            type="date"
                                                                            value={filterSalaryData.start_date}
                                                                            max={filterSalaryData.end_date}
                                                                            name="start_date"
                                                                            className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                                                            placeholder="Select Domain"
                                                                        />
                                                                        <span>{dateValidationSalary}</span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label className="medium-text font-12 d-flex mb-1">To</label>
                                                                        <input
                                                                            onChange={(e) => {
                                                                                filterSalaryOnChange(e);
                                                                            }}
                                                                            type="date"
                                                                            value={filterSalaryData.end_date}
                                                                            min={filterSalaryData.start_date}
                                                                            name="end_date"
                                                                            className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                                                            placeholder="Select Domain"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex justify-content-end mt-3">
                                                                    <a
                                                                        onClick={() => {
                                                                            setFilterSalaryData(salaryFilterData);
                                                                            applyFilter('', salaryFilterData);
                                                                        }}
                                                                        className="btn hive-btn-secondary me-3"
                                                                    >
                                                                        Clear
                                                                    </a>
                                                                    <button
                                                                        autoFocus
                                                                        onClick={() => {
                                                                            applyFilter('salary');
                                                                            setFilterValueSalary(filterSalaryData.domain);
                                                                        }}
                                                                        type="button"
                                                                        className="btn hive-btn-primary dashboard-btn-filter"
                                                                    >
                                                                        Apply
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : null}
                                        </div>
                                        <div className="col-md-12">
                                            <div className="tab-content" id="pills-tabContent">
                                                {role == 'Hr Manager' || role == 'Hr' ? (
                                                    <div
                                                        className="tab-pane fade show active"
                                                        id="team-count"
                                                        role="tabpanel"
                                                        aria-labelledby="team-count-tab"
                                                    >
                                                        <div className="text-center position-relative">
                                                            {/* <span className="rating-yaxis-style">No of Team Members</span>
                                                            <span className="rating-xaxis-style">Domains</span> */}

                                                            <TeamCountData filterFunction={passFilterData} />
                                                        </div>
                                                    </div>
                                                ) : null}

                                                {/*Ratings Tab */}
                                                {/* <div
                                                    className={`tab-pane fade ${role == 'Manager' ? 'show active' : null} `}
                                                    id="rating"
                                                    role="tabpanel"
                                                    aria-labelledby="ratings-tab"
                                                >
                                                    <div className="text-center position-relative">
                                                        <span className="rating-yaxis-style">No of Team Members</span>
                                                        <span className="rating-xaxis-style">Ratings</span>
                                                        <RatingData filterFunction={passFilterData} role={encryptStorage.getItem('role')} />
                                                    </div>
                                                </div> */}
                                                {/* Salary Range Tab*/}
                                                <div
                                                    className={`tab-pane fade ${role == 'Manager' ? 'show active' : null}`}
                                                    id="salary-range"
                                                    role="tabpanel"
                                                    aria-labelledby="salary-range-tab"
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <div className="col-md-8 text-center position-relative">
                                                            {/* <div className="text-center avg-salary" >
                                                                <p className="font-12 semibold-text avg-color mb-0">Average Salary</p>
                                                                <p className="font-15 tt-bold lpa-color">7LPA</p>
                                                            </div> */}

                                                            <SalaryData
                                                                filterFunction={passFilterData}
                                                                role={encryptStorage.getItem('role')}
                                                            />

                                                            {/* {(filterClicked) ? <SalaryData filterFunction={filterSalaryData} /> : <SalaryData filterFunction={""} />} */}
                                                            {/* <SalaryData /> */}
                                                        </div>
                                                        <div className="col-md-4 mt-4">
                                                            <div>
                                                                <label className="regular-text font-11 me-4">
                                                                    <span className="dashboard-salary-legrand-1 me-2" />
                                                                    1.2 - 4 CTC
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <label className="regular-text font-11 me-4">
                                                                    <span className="dashboard-salary-legrand-2 me-2" />4 - 8 CTC
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <label className="regular-text font-11 me-4">
                                                                    <span className="dashboard-salary-legrand-3 me-2" />8 - 12 CTC
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <label className="regular-text font-11 me-4">
                                                                    <span className="dashboard-salary-legrand-4 me-2" />
                                                                    12 - 16 CTC
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <label className="regular-text font-11 me-4">
                                                                    <span className="dashboard-salary-legrand-5 me-2" />
                                                                    16+ CTC
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dashboard-custom-col-28 rounded-5 dashboard-container-background">
                                        <MoodData role={encryptStorage.getItem('role')} />
                                    </div>
                                    <div className="dashboard-custom-col-attrition rounded-5 dashboard-container-background">
                                        <AttritionData role={encryptStorage.getItem('role')} />
                                    </div>
                                </div>
                            </div>
                            {/* Activities Tab */}
                            <div
                                className={`tab-pane fade ${Tab == 'activities' ? 'show active' : null}`}
                                id="pills-profile"
                                role="tabpanel"
                                aria-labelledby="activities-dashboard-tab"
                            >
                                <Activities />
                            </div>

                            <div
                                className={`tab-pane fade ${Tab == 'team' ? 'show active' : null}`}
                                id="pills-contact"
                                role="tabpanel"
                                aria-labelledby="myteam-dashboard-tab"
                            >
                                {/* My Team Tab */}

                                <MyTeamData />

                                {/*My Team - Ends here*/}
                            </div>

                            {/* Attrition tab */}
                            <div
                                className={`tab-pane fade ${Tab == 'attrition' ? 'show active' : null}`}
                                id="pills-Attrition"
                                role="tabpanel"
                                aria-labelledby="Attrition-dashboard-tab"
                            >
                                {/* Attrition Tab */}

                                {/* <AttritionDashboard /> */}

                                {/*Attrition - Ends here*/}
                            </div>

                        </div>
                    </div>
                </div>
                {popUp ? <FreezePane /> : null}
            </>
        );
    } else if (role == 'Team Member') {
        return (
            <>
                <Loader isLoading={isLoading} />
                <TeamMemberDashboard />
                {popUp ? <FreezePane /> : null}
            </>
        );
    }

    // }
    // catch(err){
    //
    // }
}

export default OverviewContainer;
